var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "col-md-12", staticStyle: { "padding-left": "0px" } },
      [
        _c("h4", [
          _c("span", { staticClass: "text-left" }, [
            _c("strong", [_vm._v(_vm._s(_vm.titulo))]),
          ]),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "control-label name column-nowrap bold",
              staticStyle: { float: "right" },
            },
            [
              _c("div", { class: _vm.classValorTotal }, [
                _c(
                  "span",
                  {
                    staticStyle: { "font-size": "12px" },
                    attrs: { clas: "bold" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.labelValorTotal) +
                        "\n            "
                    ),
                    _c("b", [_vm._v(_vm._s(_vm.valorTotalFormatado))]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dataTables_wrapper no-footer",
        attrs: { id: "sample_editable_1_wrapper" },
      },
      [
        _c("div", { staticClass: "table-scrollable" }, [
          _c(
            "table",
            {
              staticClass:
                "table table-striped table-hover table-bordered dataTable no-footer",
              attrs: { id: "sample_editable_1", role: "grid" },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (row) {
                  return _c(
                    "tr",
                    {
                      key: row._id,
                      staticClass: "odd",
                      attrs: { role: "row" },
                    },
                    [
                      _c("td", { staticClass: "text-center" }, [
                        _c("label", [_vm._v(_vm._s(row.Fields.COMPETENCIA))]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "input-group col-centered form" },
                          [
                            _c("wes-input-currency", {
                              attrs: {
                                isDisabled:
                                  _vm.desabilitarOrcadoNegativo &&
                                  row.Fields.ORCADO <= 0,
                                minValue: 0,
                                maxValue: _vm.validarMaximo
                                  ? row.Fields.ORCADO
                                  : null,
                              },
                              model: {
                                value: row.Fields.REMANEJAR,
                                callback: function ($$v) {
                                  _vm.$set(row.Fields, "REMANEJAR", $$v)
                                },
                                expression: "row.Fields.REMANEJAR",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.formatMoney(row.Fields.SALDO))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.formatMoney(row.Fields.ORCADO))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.formatMoney(row.Fields.REALIZADO))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.formatMoney(row.Fields.COMPROMETIDO))
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { attrs: { role: "row" } }, [
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { "min-width": "70px" } },
          [_vm._v("Competência")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { "min-width": "150px" } },
          [_vm._v("Remanejar")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { "min-width": "150px" } },
          [_vm._v("Saldo")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { "min-width": "150px" } },
          [_vm._v("Orçado")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { "min-width": "150px" } },
          [_vm._v("Realizado")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { "min-width": "150px" } },
          [_vm._v("Comprometido")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }